import {http} from '@/http'

export default {
  create(formData) {
    return http.post('/medical-leaves', formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    })
  },
  getAll(params) {
    return http.get('/medical-leaves', {params})
  },
  get(id) {
    return http.get(`/medical-leaves/${id}`)
  },
  getByEmployee(employeeId) {
    return http.get(`/medical-leaves/employee/${employeeId}`)
  },
  getSummary(employeeId) {
    return http.get(`/medical-leaves/employee/${employeeId}/summary`)
  },
  finalize(id, data) {
    return http.put(`/medical-leaves/${id}/finalize`, data)
  },
  cancel(id, data) {
    return http.put(`/medical-leaves/${id}/cancel`, data)
  },
  downloadXlsx(data) {
    return http.post('/medical-leaves/xlsx', data, {responseType: 'blob'})
  },
}
